import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../../pages/Login";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import LineBtn from "../../../../Button/LineBtn";
import AlertModal from "../../../../Modal/AlertModal";
import GradeAddModal from "../GradeAddModal/GradeAddModal";

interface GradeAddBtnProps {
  authModalOpenEvent: (name: string) => void;
}

export default function GradeAddBtn({ authModalOpenEvent }: GradeAddBtnProps) {
  const auth = useRecoilValue(authType);

  const [gradeAddModal, setGradeAddModal] = useState(false);
  const [gradeAddSuccessModal, setGradeAddSuccessModal] = useState({
    modal: false,
    gradeName: "",
  });

  return (
    <>
      <LineBtn
        btnText="등급 추가"
        btnHeight={38}
        btnClickEvent={() => setGradeAddModal(true)}
        disabled={!auth?.adminSet}
      />

      {gradeAddModal && (
        <GradeAddModal
          closeEvent={() => setGradeAddModal(false)}
          confirmEvent={(name) => {
            setGradeAddModal(false);
            setGradeAddSuccessModal({
              gradeName: name,
              modal: true,
            });
          }}
        />
      )}

      {gradeAddSuccessModal?.modal && (
        <AlertModal
          title={`${gradeAddSuccessModal?.gradeName} 관리자 등급이 추가됩니다.
      이어서 권한을 설정해 주세요.
      `}
          customConfirmBtn={
            <ConfirmBtn
              btnText="확인"
              btnColor="mint"
              btnClickEvent={() => {
                setGradeAddSuccessModal({
                  ...gradeAddSuccessModal,
                  modal: false,
                });
                authModalOpenEvent(gradeAddSuccessModal?.gradeName);
              }}
            />
          }
          customCancelBtn={<></>}
        />
      )}
    </>
  );
}
